// src/data/advertising.ts

export interface AdvContent {
    title: string;
    items: {
        caption: string;
        subcaption: string;
    }[];
}

// Регистр (база данных) ваших текстов
export const advantagesRegistry: Record<string, AdvContent> = {
    "reklama-v-zhilyh-domah": {
        title: "Преимущества размещения рекламы в жилых домах",
        items: [{
            caption: "Гарантированная высокая частота контакта",
            subcaption: "Жители дома ежедневно проходят мимо рекламного носителя как минимум дважды.\n" +
                "Повторяющийся контакт формирует устойчивое узнавание бренда на подсознательном\n" +
                "уровне."
        },
        {
            caption: "Точный геотаргетинг",
            subcaption: "Трансляция предложения исключительно тем людям, которые живут в радиусе пятиминутной\n" +
                "прогулки от вашего бизнеса. Это идеальное решение для локальных предприятий."
        },
            {
                caption: `Максимальный уровень доверия и "домашний" контекст`,
                subcaption: "Реклама, размещенная внутри жилого пространства, воспринимается лояльнее, чем\n" +
                    "агрессивные баннеры в сети или на оживленных трассах.\n" +
                    "Дом — это зона комфорта и безопасности."
            }
        ]
    },
    "reklama-v-biznes-centrah": {
        title: "Преимущества размещения рекламы в бизнес-центрах",
        items: [{
            caption: "Качественная, платежеспособная аудитория",
            subcaption: "В бизнес-центрах вы получаете прямой доступ к людям с гарантированным доходом — от офисных сотрудников среднего звена до топ-менеджеров и владельцев бизнеса."
        },
            {
                caption: "Четкий тайм-менеджмент и фокус на актуальные потребности",
                subcaption: "Сотрудники проводят в БЦ как минимум 8–9 часов в день, и их бытовые нужды в это время\n" +
                    "ограничены локацией и графиком. Реклама бьет точно в цель и предлагает решение «здесь и\n" +
                    "сейчас» или сразу после работы."
            },
            {
                caption: `Высокий статус и доверие к бренду`,
                subcaption: "Бизнес-центры класса «А» и «B» тщательно отбирают партнеров для размещения на своей\n" +
                    "территории. Бренд подсознательно воспринимается как надежный, успешный и финансово\n" +
                    "стабильный."
            }
        ]
    },
    "reklama-v-torgovyh-centrah": {
        title: "Преимущества размещения рекламы в торговых-центрах",
        items: [{
            caption: "Готовая к тратам и вовлеченная аудитория",
            subcaption: "Люди приходят в торговый центр сознательно с целью шопинга, отдыха или развлечений. У\n" +
                "них уже включен «режим покупателя», они готовы тратить деньги и открыты к восприятию\n" +
                "коммерческих предложений."
        },
            {
                caption: "Огромный трафик и разнообразие рекламных форматов",
                subcaption: "ТЦ аккумулируют гигантские потоки людей, особенно в выходные и праздничные дни. При\n" +
                    "этом площадка позволяет реализовать практически любые маркетинговые задачи благодаря\n" +
                    "обилию форматов."
            },
            {
                caption: `Семейный охват и совместное принятие решений`,
                subcaption: "Торгово-развлекательные центры — это главные локации для семейного досуга выходного\n" +
                    "дня. Здесь реклама воздействует сразу на все группы лиц, участвующих в покупке."
            }
        ]
    },
    "reklama-v-fitnes-klubah": {
        title: "Преимущества размещения рекламы в фитнес-клубах",
        items: [{
            caption: "Исключительно вовлеченная и премиальная аудитория",
            subcaption: "Посетители фитнес-клубов (особенно сегментов «комфорт» и «премиум») — это активные,\n" +
                "платежеспособные люди, которые следят за трендами и готовы платить за качество жизни."
        },
            {
                caption: "Максимальное время контакта и фокус внимания",
                subcaption: "В среднем тренировка длится от 1 до 2 часов, и все это время человек находится внутри\n" +
                    "замкнутого пространства. Реклама преследует его на каждом этапе, когда его внимание ничем\n" +
                    "не перегружено."
            },
            {
                caption: `Эффект «здоровой» ассоциации и высокое доверие`,
                subcaption: "Фитнес-центр — это место, куда приходят за самосовершенствованием, силой и здоровьем.\n" +
                    "Любой бренд, который рекламируется в этой локации, подсознательно получает кредит\n" +
                    "доверия."
            }
        ]
    },
    "reklama-v-pvz": {
        title: "Преимущества размещения рекламы в ПВЗ",
        items: [{
            caption: "Колоссальный целевой трафик и «покупательский» настрой",
            subcaption: "В ПВЗ приходят люди, которые уже являются активными покупателями.\n" +
                "Здесь вы получаете аудиторию потребителей в тот самый момент, когда они находятся в\n" +
                "отличном настроении — в предвкушении получения своих заказов."
        },
            {
                caption: "Гарантированное время ожидания (Эффект очереди)",
                subcaption: "Процесс получения посылки занимает в от 3 до 7 минут. Реклама на digital-экранах за спиной\n" +
                    "у менеджера, неизбежно притягивают взгляд. Время контакта получается качественным и\n" +
                    "длинным."
            },
            {
                caption: `Точечный геотаргетинг и «соседский» контекст`,
                subcaption: "Люди выбирают пункт в радиусе 300–500 метров от своего дома. Для локального бизнеса\n" +
                    "реклама в конкретном ПВЗ — это точный способ заявить о себе жителям ближайших домов."
            }
        ]
    },
};
